import React from 'react';
import Tile from '../ui/Tile';
import TileHeader from '../ui/TileHeader';
import { Trash2 } from 'lucide-react';
import DeletedInvoicesTable from './components/DeletedInvoicesTable';

const DeletedInvoicesList = ({
  invoices = [],
  handleRestoreDeletedInvoice,
  loadMore,
  hasMore
}) => {
  return (
    <div className="w-full mt-8">
      <Tile>
        <TileHeader title="Изтрити фактури" icon={Trash2} />
        <div className="pt-6">
          <DeletedInvoicesTable 
            invoices={invoices}
            handleRestoreDeletedInvoice={handleRestoreDeletedInvoice}
            loadMore={loadMore}
            hasMore={hasMore}
          />
        </div>
      </Tile>
    </div>
  );
};

export default DeletedInvoicesList;
